module.exports = __webpack_public_path__ + "img/logo.817ea2bb.png";